export default __webpack_public_path__ + "static/media/flag-outline.d019cc12.svg";